<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Inventering'" :sub-title="stocktaking_name" :title-id="id">
            <template #header-elements>
                <limitless-page-header-button url="/stocktaking" icon="icon-circle-left2">Tillbaka</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <tb-skeleton v-if="busy_loading" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

            <div v-else-if="!busy_loading && stocktaking">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="card">
                            <div class="card-body">
                                <ValidationObserver ref="stocktakingform">
                                    <form @submit.prevent="saveStocktaking">
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Namn: <span class="text-danger">*</span></label>
                                            <div class="col-lg-10">
                                                <input-with-validation
                                                    vid="description"
                                                    label="Namn"
                                                    rules="required"
                                                    v-model="stocktaking.description"
                                                    hide-label
                                                />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Datum: <span class="text-danger">*</span></label>
                                            <div class="col-lg-10">
                                                <ValidationProvider vid="start_date" name="Datum" rules="required" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <v-date-picker v-model="stocktaking.start_date" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                            <template v-slot="{ inputValue, togglePopover }">
                                                                <input class="form-control" :value="inputValue" @focus="togglePopover()" :class="{'has-validation-error':(!!errors[0])}">
                                                            </template>
                                                        </v-date-picker>
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Status: <span class="text-danger">*</span></label>
                                            <div class="col-lg-10">
                                                <div class="form-group">
                                                    <select-with-validation
                                                        vid="status_id"
                                                        label="Kategori"
                                                        rules="required"
                                                        v-model="stocktaking.status_id"
                                                        :options="statuses"
                                                        :reduce="item => item.id"
                                                        placeholder="Välj status..."
                                                        disabled
                                                        hide-label
                                                        :clearable="false"
                                                    />
                                                    <span class="text-muted">Status måste ändras i det grå systemet</span>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </ValidationObserver>
                            </div>
                            <div class="card-footer">
                                <div class="d-flex justify-content-end">
                                    <limitless-button ref="btnsavestocktaking" type="button" @click="saveStocktaking" :busy="busy_saving" icon="icon-floppy-disk">Save</limitless-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6" v-if="stocktaking.id > 0">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title">Åtgärder</h5>
                            </div>
                            <div class="card-body">
                                <div class="mb-3" v-if="stocktaking.has_stock_file">
                                    <a :href="'/stocktaking/' + id + '/csv'" target="_blank" class="btn btn-secondary btn-labeled btn-labeled-left">
                                        <b><i class="icon-file-download"></i></b>Ladda ner diff-lista (csv)
                                    </a>
                                </div>
                                <div>
                                    <limitless-button
                                        icon="icon-check"
                                        @click="showModalApprove"
                                        :busy="busy_approving"
                                        btn-class="btn-success"
                                        :disabled="!!(stocktaking.status_id < 10 || stocktaking.approved_sht)"
                                    >Godkänn inventering och justera lagersaldon</limitless-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <limitless-tabs :tabs="tabs" v-if="stocktaking.has_stock_file">
                    <template #tab-1>
                        <rednax-datatable :url="'/vue/stocktaking/' + id + '/items/diff'" :columns="diff_columns" :filter="table_filter" sort-by="id" sort-order="desc" @rowclick="rowClick">
                            <div class="row">
                                <div class="col-lg-3">
                                    <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                                </div>
                            </div>
<!--                            <template #cell_image="{ row }">-->
<!--                                <div v-if="row.ImageID">-->
<!--                                    <b-badge :id="`image-${row.sku}`" variant="white">-->
<!--                                        <i class="icon-image2"></i>-->
<!--                                    </b-badge>-->
<!--                                    <b-popover :target="`image-${row.sku}`" triggers="hover focus">-->
<!--                                        <LazyImage width="240px" :src="getImageUrl(row)"></LazyImage>-->
<!--                                    </b-popover>-->
<!--                                </div>-->
<!--                            </template>-->
                        </rednax-datatable>
                    </template>
                    <template #tab-2>
                        <rednax-datatable :url="'/vue/stocktaking/' + id + '/items/plus'" :columns="diff_columns" :filter="table_filter" sort-by="id" sort-order="desc" @rowclick="rowClick">
                            <div class="row">
                                <div class="col-lg-3">
                                    <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                                </div>
                            </div>
                        </rednax-datatable>
                    </template>
                    <template #tab-3>
                        <rednax-datatable :url="'/vue/stocktaking/' + id + '/items/minus'" :columns="diff_columns" :filter="table_filter" sort-by="id" sort-order="desc" @rowclick="rowClick">
                            <div class="row">
                                <div class="col-lg-3">
                                    <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                                </div>
                            </div>
                        </rednax-datatable>
                    </template>
                    <template #tab-4>
                        <rednax-datatable :url="'/vue/stocktaking/' + id + '/items/done'" :columns="diff_columns" :filter="table_filter" sort-by="id" sort-order="desc" @rowclick="rowClick">
                            <div class="row">
                                <div class="col-lg-3">
                                    <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                                </div>
                            </div>
                        </rednax-datatable>
                    </template>
                    <template #tab-5>
                        <rednax-datatable :url="'/vue/stocktaking/' + id + '/items'" :columns="items_columns" :filter="table_filter" sort-by="id" sort-order="desc" @rowclick="rowClick">
                            <div class="row">
                                <div class="col-lg-3">
                                    <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                                </div>
                            </div>
                        </rednax-datatable>
                    </template>
                </limitless-tabs>
                <div v-else-if="stocktaking.id > 0" class="card card-body">
                    <i class="text-danger">Diffar kan ej visas eftersom lagersaldon ej sparats till fil</i>
                </div>
            </div>
        </div> <!-- /content -->

        <b-modal id="modal-approve-stocktaking" title="Godkänn inventering och justera lagersaldon" @ok="approveStocktaking">
            <ValidationObserver ref="approveform">
                <div class="form-group row">
                    <label class="col-form-label col-lg-2">Datum</label>
                    <div class="col-lg-10">
                        <ValidationProvider vid="stock_date" name="Datum" rules="required" v-slot="{ errors }">
                            <v-date-picker v-model="approve.stock_date" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                <template v-slot="{ inputValue, togglePopover }">
                                    <input class="form-control" :value="inputValue" @focus="togglePopover()" placeholder="Datum">
                                </template>
                            </v-date-picker>
                            <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label col-lg-2">Kommentar</label>
                    <div class="col-lg-10">
                        <textarea-with-validation
                            vid="comment"
                            label="Kommentar"
                            :min-height="116"
                            v-model="approve.comment"
                            hide-label
                        />
                    </div>
                </div>
            </ValidationObserver>
            <template #modal-footer="{ cancel, ok }">
                <button type="button" class="btn btn-light" @click="cancel">Avbryt</button>
                <limitless-button ref="btnapprovestocktaking" type="button" @click="ok" :busy="busy_approving">Godkänn</limitless-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import LimitlessTabs from '@components/Limitless/LimitlessTabs.vue';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent.vue';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import TextareaWithValidation from '@components/Form/TextareaWithValidation.vue';

export default {
    name: 'StocktakingEdit',
    components: {
        TextareaWithValidation,
        SelectWithValidation,
        InputWithValidation,
        RednaxDatatable,
        LimitlessTabs,
        VDatePicker,
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    props: {
        id: {
            type: Number,
            default: 0,
        },
    },
    data: () => ({
        busy_loading: true,
        busy_saving: false,
        busy_approving: false,
        stocktaking: null,
        approve: {
            stock_date: null,
            comment: '',
        },
        statuses: [
            {
                id: 0,
                label: 'Kommande',
            },
            {
                id: 10,
                label: 'Aktiv',
            },
            {
                id: 100,
                label: 'Avslutad',
            },
        ],
        tabs: [
            {
                label: 'Difflista',
            },
            {
                label: 'Plusdiff',
            },
            {
                label: 'Minusdiff',
            },
            {
                label: 'Klar',
            },
            {
                label: 'Inventerat',
            },
        ],
        table_filter: {
            search: '',
        },
        diff_columns: [
            {
                header: 'SKU',
                data: 'sku',
                sortable: true,
            },
            // {
            //     header: 'Bild',
            //     data: 'image',
            //     sortable: false,
            // },
            {
                header: 'Produkt',
                data: 'product_name',
                sortable: true,
            },
            {
                header: 'Lagersaldo',
                data: 'stock',
                sortable: true,
            },
            {
                header: 'Räknat antal',
                data: 'count',
                sortable: true,
            },
            {
                header: 'Diff',
                data: 'diff',
                sortable: true,
                class(row) {
                    if (row.diff > 0) {
                        return 'bg-success-200';
                    }
                    if (row.diff < 0) {
                        return 'bg-danger-200';
                    }
                    return 'bg-primary-200';
                },
            },
            {
                header: 'Diff värde',
                data: 'diff_value',
                sortable: true,
            },
        ],
        items_columns: [
            {
                header: 'SKU',
                data: 'sku',
                sortable: true,
            },
            // {
            //     header: 'Bild',
            //     data: 'image',
            //     sortable: false,
            // },
            {
                header: 'Produkt',
                data: 'product_name',
                sortable: true,
            },
            {
                header: 'Lagersaldo',
                data: 'stock',
                sortable: true,
            },
            {
                header: 'Räknat antal',
                data: 'count',
                sortable: true,
            },
            {
                header: 'Diff',
                data: 'diff',
                sortable: true,
                class(row) {
                    if (row.diff > 0) {
                        return 'bg-success-200';
                    }
                    if (row.diff < 0) {
                        return 'bg-danger-200';
                    }
                    return 'bg-primary-200';
                },
            },
            {
                header: 'Diff värde',
                data: 'diff_value',
                sortable: true,
            },
        ],
    }),
    mounted() {
        this.init();
    },
    watch: {
        id() {
            this.init();
        },
    },
    methods: {
        init() {
            this.getStocktaking();
        },
        getStocktaking() {
            this.busy_loading = true;
            apiClient.get('/vue/stocktaking/' + this.id + '')
                .then((response) => {
                    this.stocktaking = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        async saveStocktaking() {
            const isValid = await this.$refs.stocktakingform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/stocktaking/' + this.id, this.stocktaking)
                    .then((response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.id, 10)) {
                            window.location.href = '/stocktaking/' + response.data.id;
                        }
                        this.stocktaking = response.data;
                        this.$refs.btnsavestocktaking.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.stocktakingform.setErrors(parsederror);
                        }
                        this.$refs.btnsavestocktaking.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        async approveStocktaking() {
            const isValid = await this.$refs.approveform.validate();
            if (isValid) {
                this.busy_approving = true;
                await apiClient.post('/vue/stocktaking/' + this.id + '/approve', this.approve)
                    .then((response) => {
                        this.stocktaking.approved_sht = 1;
                        let message = 'Inventeringen har godkänts';
                        if (response.data?.message) {
                            message = response.data.message;
                        }
                        this.$swal({
                            icon: 'success',
                            title: 'Wohoo!',
                            text: message,
                            confirmButtonText: 'OK',
                            cancelButtonText: 'Avbryt',
                        });
                    })
                    .catch((error) => {
                        let message = 'Något gick fel...';
                        if (error.response?.data?.message) {
                            message = error.response.data.message;
                        }
                        this.$swal({
                            icon: 'error',
                            title: 'Error!',
                            text: message,
                            confirmButtonText: 'OK',
                            cancelButtonText: 'Avbryt',
                        });
                    })
                    .finally(() => {
                        this.busy_approving = false;
                    });
            }
        },
        showModalApprove() {
            this.approve.stock_date = this.stocktaking.start_date;
            this.approve.comment = 'INVENTERING ' + this.stocktaking.start_date.substring(0, 7);
            this.$bvModal.show('modal-approve-stocktaking');
        },
        // deleteStocktaking() {
        //     // eslint-disable-next-line no-restricted-globals,no-alert
        //     if (confirm('Are you sure you want to delete this stocktaking?')) {
        //         this.busy_saving = true;
        //         apiClient.delete('/vue/stocktaking/' + this.id)
        //             .then(() => {
        //                 document.location.href = '/stocktaking';
        //                 this.busy_saving = false;
        //             })
        //             .catch(() => {
        //                 this.$refs.btndeletestocktaking.triggerFailed();
        //             })
        //             .finally(() => {
        //                 this.busy_saving = false;
        //             });
        //     }
        // },
        getImageUrl(row) {
            return '/storage/mediabank/' + ((row.ImageID.toString().substring(0, row.ImageID.toString().length - 2) + 'xx').padStart(6, '0')) + '/' + row.ImageID + '_210.jpg';
        },
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/stocktaking/' + this.id + '/sku/' + row.sku).focus();
            } else {
                this.$router.push({
                    name: 'stocktaking.item',
                    params: {
                        id: this.id,
                        sku: row.sku,
                    },
                });
            }
        },
    },
    computed: {
        stocktaking_name() {
            return (this.stocktaking && this.stocktaking.id > 0 ? this.stocktaking.description : 'New stocktaking');
        },
        stocktaking_id() {
            return (this.stocktaking && this.stocktaking.id > 0 ? this.stocktaking.id : '');
        },
    },
};

</script>
